export const BASE_API = process.env.REACT_APP_CUSTOMER_BACKEND_BASEAPI
export const GOOGLE_CLOUD_STORAGE_URL =
  process.env.REACT_APP_GOOGLE_CLOUD_STORAGE_URL
